<template>
  <div>
    <div
      v-if="cleaner"
      :style="{
      opacity: (cleaner.active==0)?0.5:1,
      'font-size': '14px',
      'line-height': '16px',
      'font-weight': foreman ? 'bold' : 'normal',
    }"
      class="my-1"
      :title="(cleaner.active==0)?lang($store, `sap/listings.global.not_active`):false"
    >
      <v-icon small>mdi-spray-bottle</v-icon>
      {{cleaner.name}}
      <span v-show="rank && cleaner.rank">
        ({{lang($store, 'sap/listings.global.filter.ranks.' + cleaner.rank)}})
      </span>
      <a v-show="phone" :href="'tel:'+formatPhoneForLink(cleaner.phone)">
        {{cleaner.phone}}
      </a>
      <span v-if="cleaner.orders_counter">
        <strong>( {{ $t('negatives.orders') + ': ' + cleaner.orders_counter }} )</strong>
        </span>
    </div>
    <slot
      v-else
      name="not-found"
      >
      <div class="red--text">
        <v-icon small>mdi-spray-bottle</v-icon>
        {{notFoundText?notFoundText:lang($store, 'sap/listings.orders.cleaner_not_set')}}
      </div>
    </slot>
  </div>

</template>

<script>
import { formatPhoneForLink } from '../../utils';

export default {
  name: 'CleanerLine',
  props: {
    cleaner: {
      type: Object,
      default: null,
    },
    foreman: {
      type: Boolean,
      default: false,
    },
    rank: {
      type: Boolean,
      default: false,
    },
    phone: {
      type: Boolean,
      default: true,
    },
    notFoundText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      formatPhoneForLink,
    };
  },
};
</script>

<style scoped>

</style>
